import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'displayDash',
    standalone: false
})
export class DisplayDashPipe implements PipeTransform {

  transform(value: string | null | undefined): string {
    return value == null || value === '' ? '-' : value;
  }

}
